//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            02nd October 2018
//  * @type            Left Design Component File
//  * @description -   This file renders the html and functionality for left(first) component when design tab is choosed.
<template>
  <!-- <v-wait>
		<template>
			<div id="leftloadingdiv" v-if="loading">
				<img src="../../assets/images/loader.gif" />
			</div>
  </template>-->
  <div class="colume_1_option_elements">
    <!-- <p>{{initialData}}</p> -->
    <div class="tab-content">
      <div class="tab-pane fade in active">
        <div class="colume_1_elements logo_colume">
          <h3>logo</h3>
          <div class="elements_sec">
            <!-- <input id="logo_img" type="file" @change="onFileChange" accept="image/*" :style="{ 'background-image' : 'url(\'' + designall.logo + '\')' }"> -->
            <image-uploader
              id="fileInputLogoImage"
              :debug="1"
              :maxWidth="1024"
              :maxHeight="80"
              :quality="0.9"
              :maxSize="1"
              :autoRotate="true"
              outputFormat="verbose"
              :preview="false"
              capture="environment"
              accept="image/*"
              :src="designall.logo"
              @input="createImage"
              :style="[designall.logo ? { 'background-image' : 'url(\'' + designall.logo + '\')' } : noimage]"
              :class="[designall.logo ? 'logo_img' : 'logo_img logo_img_before']"
            ></image-uploader>
          </div>
          <a v-if="designall.logo" href="#" class="img_delete_icon">
            <i
              @click="$awn.confirm('Are you sure you want to delete this image?',removeImage)"
              class="fa fa-times"
              aria-hidden="true"
            ></i>
          </a>
          <!-- <button v-if ="designall.logo" @click="$awn.confirm('Are you sure you want to delete this image?',removeImage)" id="logo_btn">Delete Logo</button> -->
          <!-- <img :src="designall.logo" /> -->
          <!-- <div v-if ="designall.logo">
					   <button @click="removeImage" id="logo_btn">Delete Logo</button>
          </div>-->
          <div class="elements_sec logo_align">
            <div class="answer_btn">
              <label class="switch">
                <input
                  id="align-left"
                  :value="alignleft"
                  :checked="alignleft"
                  type="radio"
                  name="align"
                  @change="updateAlign"
                >
                <span class="slider round"></span>
              </label>
              <p>left</p>
            </div>
            <div class="answer_btn">
              <label class="switch">
                <input
                  id="align-center"
                  :value="aligncenter"
                  :checked="aligncenter"
                  type="radio"
                  name="align"
                  @change="updateAlign"
                >
                <span class="slider round"></span>
              </label>
              <p>center</p>
            </div>
            <div class="answer_btn">
              <label class="switch">
                <input
                  id="align-right"
                  :value="alignright"
                  :checked="alignright"
                  type="radio"
                  name="align"
                  @change="updateAlign"
                >
                <span class="slider round"></span>
              </label>
              <p>right</p>
            </div>
          </div>
        </div>
        <div class="colume_1_elements bg_img_colume">
          <h3>background image</h3>
          <div class="elements_sec">
            <!-- <div id="image-preview"> -->
            <!-- <label for="image-upload" id="image-label">Choose File</label> -->
            <image-uploader
              id="fileInputBgImage"
              :debug="1"
              :maxWidth="2732"
              :maxHeight="2048"
              :quality="0.9"
              :autoRotate="true"
              outputFormat="verbose"
              :preview="false"
              capture="environment"
              :src="designall.bg_image"
              @change="createBgImage"
              :class="[designall.bg_image ? 'bg_img' : 'bg_img bg_img_before']"
              :style="[designall.bg_image ? { 'background-image' : 'url(\'' + designall.bg_image + '\')' } : noimage]"
            ></image-uploader>
            <a v-if="designall.bg_image" href="#" class="img_delete_icon">
              <i
                @click="$awn.confirm('Are you sure you want to delete this image?',removebgImage)"
                class="fa fa-times"
                aria-hidden="true"
              ></i>
            </a>
            <!-- <button v-if ="designall.bg_image" @click="$awn.confirm('Are you sure you want to delete this image?',removebgImage)" id="logo_btn">Delete Image</button>
            -->
            <!-- <input type="file" name="image" id="image-upload" @change="onFileChange" :style="{ 'background-image' : 'url(\'' + designall.bg_image + '\')' }"/> -->
            <!-- </div> -->
          </div>
          <!-- v-if="!designall.bg_image" <div v-else class="elements_sec">
					   <img :src="designall.bg_image" />
					   <a @click="removebgImage" id="bg_btn"><i class="fa fa-repeat" aria-hidden="true"></i> replace</a>
					   <button @click="removebgImage" id="bg_btn">Change background image</button>
          </div>-->
        </div>
        <div class="colume_1_elements theme_btn_colours">
          <h3>colours</h3>
          <div class="elements_sec">
            <div class="col-md-5 colours_btn_name p-0">
              <span>text</span>
            </div>
            <div class="col-md-2 colours_btn_color p-0">
              <verte v-model="verte1" picker="square" model="hex">
                <!-- <svg width="50" height="50" viewBox="0 0 24 24">
									<path d="M0 20h24v4H0z"/>
									<path style="fill: #000" d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"/>
								  <rect width="50" height="50" style="fill: #000;" d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"/>
                </svg>-->
                <!-- <svg viewBox="0 0 24 24">
								     <path d="M0 20h24v4H0z"/>
								     <path style="fill: #000" d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"/>
                </svg>-->
              </verte>
            </div>
            <div class="col-md-5 colours_btn_pic p-0">
              <input
                ref="text_color"
                class="jscolor"
                id="text_color"
                :value="designall.text_color"
                @blur="updateVerte"
              >
              <i id="text_color" @click="setFocus" class="fa fa-pencil" aria-hidden="true"></i>
            </div>
          </div>
          <div class="elements_sec">
            <div class="col-md-5 colours_btn_name p-0">
              <span>button</span>
            </div>
            <div class="col-md-2 colours_btn_color p-0">
              <verte v-model="verte2" picker="square" model="hex"></verte>
            </div>

            <div class="col-md-5 colours_btn_pic p-0">
              <input
                ref="button_color"
                class="jscolor"
                id="button_color"
                :value="designall.button_color"
                @blur="updateVerte"
              >
              <i id="button_color" @click="setFocus" class="fa fa-pencil" aria-hidden="true"></i>
            </div>
          </div>
          <div class="elements_sec">
            <div class="col-md-5 colours_btn_name p-0">
              <span>button text</span>
            </div>
            <div class="col-md-2 colours_btn_color p-0">
              <verte v-model="verte3" picker="square" model="hex"></verte>
            </div>
            <div class="col-md-5 colours_btn_pic p-0">
              <input
                ref="button_text_color"
                class="jscolor"
                id="button_text_color"
                :value="designall.button_text_color"
                @blur="updateVerte"
              >
              <i id="button_text_color" @click="setFocus" class="fa fa-pencil" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </v-wait> -->
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "designleft",
  // props:['initialData'],
  data() {
    return {
      alignleft: 0,
      aligncenter: 0,
      alignright: 0,
      verte1: "#000000",
      verte2: "#000000",
      verte3: "#000000",
      noimage: { 'border': '1px solid #f8f8f8', 'background': '#f8f8f8', 'color': '#969696', 'position': 'relative' }//require("../../assets/images/no-image-square.jpg")
    };
  },
  computed: {
    ...mapGetters("LeftSidebarCreate", ["designall", "loading"])
  },
  watch: {
    verte1: {
      handler(newVal, oldVal) {
        if (newVal !== this.designall.text_color && newVal) {
          // triggered when anything is changed within the Object all
          var e1 = { target: { id: "text_color", value: newVal } };
          this.updtVerte([e1, this.sessionData]);
        }
      }
    },
    verte2: {
      handler(newVal, oldVal) {
        if (newVal !== this.designall.button_color && newVal) {
          // triggered when anything is changed within the Object all
          var e1 = { target: { id: "button_color", value: newVal } };
          this.updtVerte([e1, this.sessionData]);
        }
      }
    },
    verte3: {
      handler(newVal, oldVal) {
        if (newVal !== this.designall.button_text_color && newVal) {
          var e1 = { target: { id: "button_text_color", value: newVal } };
          this.updtVerte([e1, this.sessionData]);
        }
      }
    }
  },
  created() {
    // to set if data is being retrieved from api
    let timeout = 0;
    if (this.designall.text_color ? "" : (timeout = 1000)) {
    }

    setTimeout(() => {
      this.sessionData = this.$session.getAll();
      this.sessionData["in_survey_Id"] = this.$route.params.id;
      if (this.designall.text_color) {
        if (this.designall.logo_align == 0) {
          this.alignleft = 1;
        } else if (this.designall.logo_align == 1) {
          this.aligncenter = 1;
        } else {
          this.alignright = 1;
        }
        this.verte1 = this.designall.text_color;
        this.verte2 = this.designall.button_color;
        this.verte3 = this.designall.button_text_color;
      }
    }, timeout);
  },
  methods: {
    ...mapActions("LeftSidebarCreate", [
      "setDesign_img",
      "rmvDesign_img",
      "setDesign_bgimg",
      "rmvDesign_bgimg",
      "updtVerte",
      "updtAlign"
    ]),
    createImage(file) {
      if (!file.dataUrl) {
        return;
      }
      var reader = new FileReader();
      var ext = file.name.substring(file.name.indexOf(".") + 1);

      if (ext == "png" || ext == "jpg" || ext == "jpeg") {
        this.setDesign_img([file, this.sessionData]);
      } else {
        this.$awn.alert("Image type should be png or jpeg");
      }
    },
    createBgImage(file) {
      if (!file.dataUrl) {
        return;
      }
      var reader = new FileReader();
      var ext = file.name.substring(file.name.indexOf(".") + 1);

      if (ext == "png" || ext == "jpg" || ext == "jpeg") {
        this.setDesign_bgimg([file, this.sessionData]);
        // vm.designall.logo = e.target.result;
      } else {
        this.$awn.alert("Image type should be png or jpeg");
      }
    },
    removeImage: function(e) {
      $("#fileInputLogoImage")[0].value = null;
      this.rmvDesign_img(this.sessionData);
    },
    removebgImage: function(e) {
      $("#fileInputBgImage")[0].value = null;
      this.rmvDesign_bgimg(this.sessionData);
    },

    updateVerte(e) {
      if (e.target.id == "text_color" && e.target) {
        this.verte1 = e.target.value;
      } else if (e.target.id == "button_color" && e.target) {
        this.verte2 = e.target.value;
      } else if (e.target) {
        this.verte3 = e.target.value;
      }
    },
    updateAlign(e) {
      if (e.target.id == "align-left") {
        this.alignleft = 1;
        this.alignright = 0;
        this.aligncenter = 0;
      } else if (e.target.id == "align-center") {
        this.aligncenter = 1;
        this.alignleft = 0;
        this.alignright = 0;
      } else {
        this.alignright = 1;
        this.aligncenter = 0;
        this.alignleft = 0;
      }
      this.updtAlign([e, this.sessionData]);
    },
    setFocus(e) {
      console.log(e);
      this.$refs[e.target.id].focus();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/designleft.vue